const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/messages/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { loadMobileMessagesContent, preloadMobilePage } from "@/react/components/Mobile/utils/mobilePageLoaders";
export const Route = createFileRoute("/_protected/messages/")({
  loader: preloadMobilePage(loadMobileMessagesContent),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});